import React from "react";
import env from "env";
import { Table } from "components/table/table";
import { useRouter } from "components";
import { useGet } from "components";
import { SiteLink } from "components";
import { Loading, ErrorPopup } from "components";

export function StoreList(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "storeName",
        Cell: (c) => {
          //console.log(c.row)
          return (
            <SiteLink to={`/admin/store/edit/${c.row.original.storeCode}`}>
              <b>{c.cell.value}</b>
            </SiteLink>
          );
        },
      },
      {
        Header: "Seq",
        accessor: "seq",
      },
      {
        Header: "Buy Online",
        accessor: "buyOnline",
        Cell: (c) => (c.cell.value === true ? "Y" : "N"),
      },
      {
        Header: "Url",
        accessor: "storeUrl",
      },
    ],
    []
  );

  const get = useGet();

  React.useEffect(() => {
    get.send(env.apiBase + "/api/storeAdmin/getStores");
    // eslint-disable-next-line
  }, []);

  if (get.loading()) {
    return <Loading />;
  } else if (get.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={get.errors} />;
  }

  const data = get.response;
  const filtered = data;

  return (
    <>
      <h1>Store List</h1>
      <div className="filter" style={{ minHeight: "30px" }}>
        <SiteLink className="btn btn-outline-primary" to={`/admin/store/new`}>
          Add Store
        </SiteLink>
      </div>
      <Table columns={columns} data={filtered} />
    </>
  );
}
